const getComponentDescriptionFromSummary = (components, component) => {
    const foundComponent = components.filter(
        (item) => item.name === component,
    ).shift();
    return foundComponent ? foundComponent.status : '';
};

export default getComponentDescriptionFromSummary;
